// const baseURL = "http://localhost:8800"
const baseURL = "https://api-admin.windtransfer.net"
export default baseURL;